import React from 'react';
import { Card } from 'reactstrap';
import './css/RecommendedProfileCard.css';
import { DEFAULT_USER_AVATAR, ROLE } from '../../shared/constants/common';
import ViewProfileButton from '../buttons/ViewProfileButton';
import FollowPPVCreatorButton from '../buttons/FollowPPVCreatorButton';
import { getSubscriptionPriceWithExtraCharge } from '../../shared/utils/paymentUtil';

const RecommendedProfileCard = ({
  profile,
  vatPercentage = 0,
  onFollowSuccess,
  onUnfollowSuccess
}) => {
  return (
    <Card className="recommended-card">
      <div className="recommended-content">
        <img
          src={profile.avatar || profile.profile_picture || DEFAULT_USER_AVATAR}
          alt="Creator Avatar"
          className="recommended-avatar"
          onError={(e) => {
            e.target.src = DEFAULT_USER_AVATAR;
          }}
        />
        <div className="recommended-details">
          <h3 className="recommended-username">{profile.username}</h3>
          <div className="recommended-info">
            {profile?.price ? (
              <span className="recommended-price">
                {`${getSubscriptionPriceWithExtraCharge(profile.price, profile?.active_promotion, vatPercentage)}`}
              </span>
            ) : profile?.subscribers > 0 ? (
              <div className="recommended-followers">
                <i className="fa-solid fa-users"></i>
                <span>
                  {profile?.subscribers}{' '}
                  {profile?.subscribers < 2 ? 'follower' : 'followers'}
                </span>
              </div>
            ) : null}
          </div>
        </div>
        <div className="recommended-actions">
          {profile.rol === ROLE.CREATOR_CONTENT && (
            <FollowPPVCreatorButton
              creator={profile}
              onFollowSuccess={onFollowSuccess}
              onUnfollowSuccess={onUnfollowSuccess}
            >
              <button className={`follow-btn ${profile.isFollowing ? 'following' : ''}`}>
                {profile.isFollowing ? 'Following' : 'Follow'}
              </button>
            </FollowPPVCreatorButton>
          )}
          <ViewProfileButton creator={profile}>
            <button className="mt-auto cm_outline_primary">
              View Profile
            </button>
          </ViewProfileButton>
        </div>
      </div>
    </Card>
  );
};

export default RecommendedProfileCard;

